var _path, _g, _path2, _g2, _path3, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGateio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 30,
    viewBox: "0 0 132 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_881_6066)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_881_6066",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 132,
    height: 30
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.501587 0H131.506V30H0.501587V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_881_6066)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.956 8.91562H112.676V5.19427H108.956V8.91562ZM89.1808 15.1129C89.8918 13.2273 91.7122 11.8848 93.8468 11.8848C95.9812 11.8848 97.8016 13.2273 98.5128 15.1129H89.1808ZM93.8468 8.42486C89.1833 8.42486 85.4015 12.2069 85.4015 16.8724C85.4015 21.5379 89.1833 25.3194 93.8468 25.3194C97.0471 25.3194 99.8311 23.5396 101.264 20.9162L98.1435 19.4019C97.2764 20.8723 95.6772 21.8594 93.8468 21.8594C91.5342 21.8594 89.5903 20.2847 89.0262 18.149H98.6672C98.6665 18.1505 98.6662 18.1527 98.6659 18.1546H102.197C102.261 17.7363 102.294 17.3081 102.294 16.8724C102.294 12.2069 98.5119 8.42486 93.8468 8.42486ZM103.274 24.869H106.995V21.1477H103.274V24.869ZM108.956 24.869H112.676V10.5516H108.956V24.869ZM123.061 21.8594C120.307 21.8594 118.074 19.6265 118.074 16.8724C118.074 14.1177 120.307 11.8848 123.061 11.8848C125.814 11.8848 128.047 14.1177 128.047 16.8724C128.047 19.6265 125.814 21.8594 123.061 21.8594ZM123.059 8.42486C118.396 8.42486 114.614 12.2069 114.614 16.8724C114.614 21.5379 118.396 25.3194 123.059 25.3194C127.724 25.3194 131.506 21.5379 131.506 16.8724C131.506 12.2069 127.724 8.42486 123.059 8.42486ZM45.2727 13.7585V17.6062H50.4748C50.2032 18.7057 49.6662 19.691 48.8961 20.478C47.7347 21.6652 46.1243 22.3194 44.3611 22.3194C40.7025 22.3194 37.7256 19.3421 37.7256 15.6824C37.7256 12.0227 40.7025 9.04508 44.3611 9.04508C46.3209 9.04508 48.1223 9.88408 49.3712 11.3312L52.3497 8.89695C50.3749 6.58223 47.445 5.19708 44.3611 5.19708C38.5813 5.19708 33.8788 9.90089 33.8788 15.6824C33.8788 21.4639 38.5813 26.1674 44.3611 26.1674C47.1675 26.1674 49.7545 25.156 51.6459 23.2228C53.233 21.6002 54.2849 19.3368 54.4871 17.0694C54.5857 15.9634 54.5948 14.8649 54.5366 13.7585H45.2727ZM64.223 21.8604C61.4692 21.8604 59.2365 19.6269 59.2365 16.8724C59.2365 14.1174 61.4692 11.8845 64.223 11.8845C66.9771 11.8845 69.2098 14.1174 69.2098 16.8724C69.2098 19.6269 66.9771 21.8604 64.223 21.8604ZM69.2104 10.0711C67.8125 9.04601 66.0888 8.43917 64.223 8.43917C59.5595 8.43917 55.7789 12.2209 55.7789 16.8855C55.7789 21.5507 59.5595 25.3318 64.223 25.3318C66.0888 25.3318 67.8125 24.7253 69.2104 23.7002V24.869H72.6673V8.90224H69.2104V10.0711ZM80.0884 5.19459H76.6311V8.91562H74.559V12.1792H76.6311V20.7198C76.6311 21.6017 76.7419 22.3436 76.9615 22.9259C77.1781 23.5019 77.5091 23.9529 77.9027 24.3052C78.3016 24.6627 78.7695 24.9412 79.3243 25.0993C79.888 25.2581 80.51 25.3194 81.1674 25.3194C81.8478 25.3194 82.4545 25.2487 82.9723 25.109C83.4529 24.9798 83.9137 24.7972 84.3425 24.565V21.9354C83.6605 22.2304 83.023 22.3371 82.2955 22.371C81.5277 22.4071 81.0734 22.1877 80.6954 21.8274C80.2993 21.4499 80.0884 20.9579 80.0884 20.1326V12.1792H84.3425V8.91562H80.0884V5.19459Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_881_6066",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 132,
    height: 30
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.501587 0H131.506V30H0.501587V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_881_6066)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4983 23.25C10.9431 23.25 7.25029 19.5567 7.25029 15.0001C7.25029 10.4438 10.9431 6.74984 15.4983 6.74984V-0.00012207C7.21576 -0.00012207 0.501587 6.7156 0.501587 15.0001C0.501587 23.2843 7.21576 30 15.4983 30C23.7806 30 30.4951 23.2843 30.4951 15.0001H23.7464C23.7464 19.5567 20.0536 23.25 15.4983 23.25Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_881_6066",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 132,
    height: 30
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.501587 0H131.506V30H0.501587V0Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_881_6066)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4983 14.9999H23.7463V6.74994H15.4983V14.9999Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_881_6066"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 131.004,
    height: 30,
    fill: "white",
    transform: "translate(0.501587)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGateio);
export default __webpack_public_path__ + "static/media/gateio.57b86d94e1ba1073d3e41fa70fcef898.svg";
export { ForwardRef as ReactComponent };